/* A26 E497 (21.10.2026): „Form wählen“ und Formnamen je Shop-Sprache */
window.a26Txt = (function () {
  var l = (document.documentElement.lang || 'de').slice(0, 2);
  var W = {
    es: { 'Farbe wählen': 'Elige el color', 'Form wählen': 'Elige la forma', Rechteckig: 'Rectangular', Rund: 'Redonda', 'Läufer': 'Pasillo', Quadratisch: 'Cuadrada', Oval: 'Ovalada' },
    fr: { 'Farbe wählen': 'Choisir la couleur', 'Form wählen': 'Choisir la forme', Rechteckig: 'Rectangulaire', Rund: 'Rond', 'Läufer': 'Couloir', Quadratisch: 'Carré', Oval: 'Ovale' },
    it: { 'Farbe wählen': 'Scegli il colore', 'Form wählen': 'Scegli la forma', Rechteckig: 'Rettangolare', Rund: 'Rotondo', 'Läufer': 'Passatoia', Quadratisch: 'Quadrato', Oval: 'Ovale' },
    en: { 'Farbe wählen': 'Choose colour', 'Form wählen': 'Choose shape', Rechteckig: 'Rectangular', Rund: 'Round', 'Läufer': 'Runner', Quadratisch: 'Square', Oval: 'Oval' }
  };
  var m = W[l] || {};
  return function (k) { return (k && m[k]) || k; };
})();
/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.resultsContainer = document.querySelector(
      "#predictive-search-results-new"
    );
    this.loadingState = this.resultsContainer.querySelector(
      ".predictive-search__loading-state"
    );
    this.results = this.resultsContainer.querySelector(
      ".predictive-search__results"
    );
    this.searchForm = this.querySelector('form[action="/search"]');

    this.setupEventListeners();
    this.debounceTimeout = null;
  }

  setupEventListeners() {
    this.input.addEventListener(
      "input",
      this.debounce(this.onChange.bind(this), 300)
    );
    this.input.addEventListener("focus", this.onFocus.bind(this));

    // Prevent the input click from bubbling up to the document click handler
    this.input.addEventListener("click", (event) => {
      event.stopPropagation();
    });

    this.searchForm.addEventListener("submit", (event) => {
      event.preventDefault();

      // Check if input value contains only numbers and has at least 2 digits
      let searchTerm = this.input.value.trim();
      if (/^\d{3,}$/.test(searchTerm)) {
        // Create a hidden input to send the modified search term
        const hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = this.input.name;
        hiddenInput.value = this.checkZeros(searchTerm);
        this.searchForm.appendChild(hiddenInput);

        // Temporarily disable the original input for submission
        this.input.name = this.input.name + "_original";
      }

      this.searchForm.submit();
    });

    // Close predictive search when clicking outside
    document.addEventListener("click", (event) => {
      // Don't close if clicking within the search component or results
      if (
        this.contains(event.target) ||
        this.resultsContainer.contains(event.target)
      ) {
        return;
      }

      this.close();
    });
  }

  debounce(fn, wait) {
    return (...args) => {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  onChange() {
    let searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    searchTerm = this.checkZeros(searchTerm);

    this.getSearchResults(searchTerm);
  }

  onFocus() {
    let searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      return;
    }

    searchTerm = this.checkZeros(searchTerm);

    this.getSearchResults(searchTerm);
  }

  async getSearchResults(searchTerm) {
    this.showLoading();

    try {
      const searchResponse = await fetch(
        `/search/suggest?q=${searchTerm}&resources[limit]=8&resources[options][unavailable_products]=${window.themeVariables.settings.searchUnavailableProducts || 'hide'}&resources[options][fields]=title,product_type,variants.title,variants.sku&section_id=predictive-search-new`
      );
      const searchData = await searchResponse.text();

      this.hideLoading();
      this.renderSearchResults(searchData);
    } catch (error) {
      console.error("Error fetching search results:", error);
      this.close();
    }
  }

  renderSearchResults(data) {
    this.results.innerHTML = data;
    this.open();
  }

  showLoading() {
    this.loadingState.hidden = false;
    this.results.hidden = true;
  }

  hideLoading() {
    this.loadingState.hidden = true;
    this.results.hidden = false;
  }

  open() {
    this.resultsContainer.hidden = false;
    this.results.hidden = false;
    this.input.setAttribute("aria-expanded", "true");
  }

  close() {
    this.resultsContainer.hidden = true;
    this.results.hidden = true;
    this.input.setAttribute("aria-expanded", "false");
  }

  checkZeros(searchTerm) {
    if (/^\d{3,}$/.test(searchTerm)) {
      // Count leading zeros
      const leadingZeros = searchTerm.match(/^0*/)[0].length;

      // Calculate how many zeros to add (up to 3)
      const zerosToAdd = Math.max(0, 3 - leadingZeros);

      // Add the required number of zeros at the beginning
      if (zerosToAdd > 0) {
        return (searchTerm = "0".repeat(zerosToAdd) + searchTerm);
      } else {
        return searchTerm;
      }
    } else {
      return searchTerm;
    }
  }
}

customElements.define("predictive-search", PredictiveSearch);

class IndividualFilterButton extends HTMLButtonElement {
  constructor() {
    super();
  }

  get controlledElement() {
    return document.getElementById(this.getAttribute("aria-controls"));
  }

  get filterGroup() {
    return this.getAttribute("data-filter-group");
  }

  connectedCallback() {
    this.filterItems = Array.from(
      document.querySelectorAll(".product-facet__filter-item")
    );
    this.addEventListener("click", this.handleClick.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick.bind(this));
  }

  handleClick() {
    this.controlledElement.open = true;

    const openFilterItems = this.filterItems.filter((item) => {
      return (
        item.querySelector("button").getAttribute("aria-expanded") === "true"
      );
    });
    const filterGroupToOpen = this.filterItems.find((item) => {
      return (
        item.querySelector("button").getAttribute("aria-controls") ===
        this.filterGroup
      );
    });

    openFilterItems.forEach((item) => {
      item.querySelector("button").setAttribute("aria-expanded", "false");
      item.querySelector("collapsible-content").open = false;
    });

    // Then, find and open the specific filter group
    setTimeout(() => {
      filterGroupToOpen
        .querySelector("button")
        .setAttribute("aria-expanded", "true");
      filterGroupToOpen.querySelector("collapsible-content").open = true;
    }, 50); // Small delay to ensure drawer is open
  }
}

customElements.define("individual-filter-button", IndividualFilterButton, {
  extends: "button",
});

class OptionRerender extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", this.handleClick.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick.bind(this));
  }

  get handle() {
    return this.getAttribute("data-handle");
  }

  get sectionId() {
    return this.getAttribute("data-section-id");
  }

  get sectionsToRerender() {
    return [
      `${this.sectionId.split("__")[0]}__main`,
      `${this.sectionId.split("__")[0]}__product-content`,
    ];
  }

  get elementsToRerender() {
    return {
      [`${this.sectionId.split("__")[0]}__main`]: {
        productSection: `.shopify-section--main-product section`,
        variantPickerDrawer: `.shopify-section--main-product #variant-picker-drawer`,
      },
      [`${this.sectionId.split("__")[0]}__product-content`]: {
        productContent: `.shopify-section--product-content`,
      },
    };
  }

  async handleClick() {
    const sectionsParam = this.sectionsToRerender.join(",");
    const response = await fetch(
      `/products/${this.handle}?sections=${sectionsParam}`
    );
    const sectionsData = await response.json();

    // Process each section's data
    Object.entries(sectionsData).forEach(([sectionId, html]) => {
      const fakeDiv = document.createElement("div");
      fakeDiv.innerHTML = html;

      // Get the elements to update for this section
      const elementsForSection = this.elementsToRerender[sectionId];
      if (elementsForSection) {
        Object.entries(elementsForSection).forEach(([key, selector]) => {
          const targetElement = document.querySelector(selector);
          const sourceElement = fakeDiv.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.innerHTML = sourceElement.innerHTML;
          }
        });
      }
    });

    window.history.pushState({}, "", `/products/${this.handle}`);
  }
}
customElements.define("option-rerender", OptionRerender);

class GridSwatches extends HTMLElement {
  constructor() {
    super();

    this.swatchItems = null;
    this.itemImages = null;
  }

  get variantParents() {
    return JSON.parse(this.getAttribute("data-variant-parents"));
  }

  connectedCallback() {
    this.productData = this.querySelector(".product-json") ? JSON.parse(this.querySelector(".product-json").innerHTML) : null;
    this.productItem = this.closest("product-item");
    this.itemImageContainer = this.productItem.querySelector(
      ".product-item__aspect-ratio"
    );
    this.swatchList = this.querySelector(".product-item-meta__swatch-list");
    this._addColorSwatchList();
  }

  // We have to add the color swatch list after the product item has been rendered, since we cannot render with with liquid
  // we are also adding all of the images to the product item for smoothing rendering
  async _addColorSwatchList() {
    if (!this.variantParents || this.variantParents.length === 0 || !this.productData) {
      this.swatchList.innerHTML = ``;
      return;
    }
    window.productDataPromise.then((data) => {
      data.forEach((product) => {
        product.variants.forEach((variant) => {
          const skuFirstPart = variant.sku.split(".")[0];
          if (this.variantParents.includes(skuFirstPart)) {
            // Add the product handle to matchingProducts if not already present
            if (!this.matchingProducts) this.matchingProducts = [];
            if (
              !this.matchingProducts.some((p) => p.handle === product.handle)
            ) {
              this.matchingProducts.push(product);
            }

            // Check for custom form and add unique shapes
            const formValue = product.shape;
            if (formValue) {
              if (!this.shapes) this.shapes = [];
              if (!this.shapes.includes(formValue)) {
                this.shapes.push(formValue);
              }
            }

            // Break out of the inner loop (for variants)
            return;
          }
        });
      });
      if (this.matchingProducts && this.matchingProducts.length > 1 && this.productData.featured_image !== null) {
        this.swatchList.innerHTML = `
          <div class="variant-swatch">
            <button data-item-rerender data-media-id="${this.productData.featured_media_id}" data-product-handle="${this.productData.handle}" class="variant-swatch__item is-selected">
              <span class="visually-hidden">${this.productData.title}</span>
              <img src="${this.productData.featured_image}" width="150" loading="eager" sizes="(max-width: 740px) 64px, 72px" srcset="${this.productData.featured_image} 64w, ${this.productData.featured_image} 72w, ${this.productData.featured_image} 128w, ${this.productData.featured_image} 144w, ${this.productData.featured_image} 192w, ${this.productData.featured_image} 216w" class="variant-swatch__image" alt="${this.productData.title}">
            </button>
          </div>
          ${(() => {
            // First, filter all products that pass the condition and count them
            const validProducts = this.matchingProducts
              .map((product) => {
                const currentProduct = window.productData.find(
                  (p) => p.handle === product.handle
                );
                if (
                  !currentProduct ||
                  currentProduct.handle === this.productData.handle ||
                  !currentProduct.shape ||
                  currentProduct.shape !== this.productData.shape ||
                  !currentProduct.available ||
                  !currentProduct.featured_image
                ) {
                  return null;
                }
                return currentProduct;
              })
              .filter(Boolean);

            // Render up to 2 products
            const rendered = validProducts.slice(0, 2)
              .map((currentProduct) => {
                const currentProductFeaturedImage = document.createElement("img");
                // Build srcset for the image using the featured_image_full as the base URL
                const baseImageUrl = currentProduct.featured_image_full.split('?')[0];
                const imageQuery = currentProduct.featured_image_full.includes('?') ? currentProduct.featured_image_full.split('?')[1] : '';
                const widths = [200,300,400,500,600,700,800,900,1000,1100,1200];
                const srcset = widths.map(
                  w => `${baseImageUrl}?${imageQuery}&width=${w} ${w}w`
                ).join(', ');
                currentProductFeaturedImage.src = `${baseImageUrl}?${imageQuery}&width=1920`;
                currentProductFeaturedImage.setAttribute("srcset", srcset);
                currentProductFeaturedImage.setAttribute("width", "1920");
                currentProductFeaturedImage.loading = "lazy";
                currentProductFeaturedImage.sizes = "(max-width: 740px) calc(50vw - 24px), calc((min(100vw - 80px, 1520px) - 0px) / 4 - 18px)";
                currentProductFeaturedImage.classList.add("product-item__primary-image");
                currentProductFeaturedImage.alt = currentProduct.title;
                currentProductFeaturedImage.setAttribute("data-media-id", currentProduct.featured_media_id);
                currentProductFeaturedImage.setAttribute("data-product-handle", currentProduct.handle);
                currentProductFeaturedImage.setAttribute("alt", currentProduct.title);
                currentProductFeaturedImage.setAttribute("hidden", "hidden");
                
                this.productItem.querySelector(".product-item__aspect-ratio").appendChild(currentProductFeaturedImage);
                return `
                  <div class="variant-swatch">
                    <button data-item-rerender data-media-id="${currentProduct.featured_media_id}" data-product-handle="${currentProduct.handle}" class="variant-swatch__item">
                      <span class="visually-hidden">${currentProduct.title || ""}</span>
                      <img src="${currentProduct.featured_image}" width="150" loading="eager" sizes="(max-width: 740px) 64px, 72px" srcset="${currentProduct.featured_image} 64w, ${currentProduct.featured_image} 72w, ${currentProduct.featured_image} 128w, ${currentProduct.featured_image} 144w, ${currentProduct.featured_image} 192w, ${currentProduct.featured_image} 216w" class="variant-swatch__image" alt="${currentProduct.title || ""}">
                    </button>
                  </div>
                `;
              })
              .join("");

            // If there are more than 2 valid products, add a link
            const moreCount = validProducts.length - 2;
            const moreLink =
              moreCount > 0
                ? `<a href="${this.productData.url || "#"}" class="link link--normal product-item-meta__swatch-list-more">+ ${moreCount}</a>`
                : "";

            return rendered + moreLink;
          })()}
        `;
      } else {
        this.swatchList.innerHTML = ``;
      }

      this._addEventListeners();
    });
  }

  _addEventListeners() {
    this.swatchItems = this.swatchList.querySelectorAll("[data-item-rerender]")
    this.swatchItems.forEach((item) => {
      item.addEventListener("click", this._handleSwatchClick.bind(this));
    });
    this.swatchList.classList.remove("visible-hidden");
  }

  _handleSwatchClick(event) {
    this.productItem.classList.add("loading");
    try {
      fetch(
        `${Shopify.routes.root}products/${event.target.dataset.productHandle}?section_id=product-item-data`
      )
        .then((response) => response.text())
        .then((html) => {
          const fakeDiv = document.createElement("div");
          fakeDiv.innerHTML = html;

          const title = this.productItem.querySelector(
            ".product-item-meta__title"
          );
          const price = this.productItem.querySelector(
            ".product-item-meta__price-list-container"
          );
          const labels = this.productItem.querySelector(
            ".product-item__label-list"
          );

          // this is if the product item is a variant since we have to handle the title and price differently
          if (this.productItem.dataset.variantId) {
            const currentVariantData = Array.from(
              fakeDiv.querySelectorAll("[data-size-filter]")
            ).find((sizeFilter) => {
              return (
                sizeFilter.dataset.sizeFilter ===
                this.productItem.dataset.sizeFilter
              );
            });

            title.innerHTML = currentVariantData.querySelector(
              ".product-item-meta__title"
            ).innerHTML;
            price.innerHTML = currentVariantData.querySelector(
              ".product-item-meta__price-list-container"
            ).innerHTML;

            Array.from(
              this.productItem.querySelectorAll('[href*="/products"]')
            ).forEach((link) => {
              const url = new URL(
                `/products/${event.target.dataset.productHandle}`,
                `https://${window.location.host}`
              );
              if (this.productItem.dataset.variantId) {
                url.searchParams.set(
                  "variant",
                  currentVariantData.dataset.variantId
                );
              }
              link.setAttribute("href", url.toString());
            });
          } else {
            // this is if the product item is a product

            title.innerHTML = fakeDiv.querySelector(
              ".product-item-meta__title"
            ).innerHTML;
            price.innerHTML = fakeDiv.querySelector(
              ".product-item-meta__price-list-container"
            ).innerHTML;

            if (labels) {
              labels.innerHTML = fakeDiv.querySelector(
                ".product-item__label-list"
              )
                ? fakeDiv.querySelector(".product-item__label-list").innerHTML
                : "";
            }

            Array.from(
              this.productItem.querySelectorAll('[href*="/products"]')
            ).forEach((link) => {
              const url = new URL(
                `/products/${event.target.dataset.productHandle}`,
                `https://${window.location.host}`
              );
              link.setAttribute("href", url.toString());
            });
          }

          this.productItem.querySelectorAll(".product-item__primary-image").forEach((image) => {
            if (image.dataset.mediaId === event.target.dataset.mediaId) {
              image.removeAttribute("hidden");
            } else {
              image.setAttribute("hidden", "");
            }
          });

          this.swatchItems.forEach((item) => {
            item.classList.remove("is-selected");
          });

          event.target.classList.add("is-selected");

          this.productItem.classList.remove("loading");
        });
    } catch (error) {
      console.error("Error fetching product data:", error);
    } finally {
      this.productItem.classList.remove("loading");
    }
  }
}

customElements.define("grid-swatches", GridSwatches);

document.addEventListener("variant:changed", (event) => {
  const { variant } = event.detail;
  const optionButtons = Array.from(
    document.querySelectorAll("[data-option-button]")
  );

  if (optionButtons.length > 0) {
    updateOptionButtons(variant, optionButtons);
  }
});

function updateOptionButtons(variant, optionButtons) {
  optionButtons.forEach((button) => {
    const textElement = button.querySelector(".product-form__option-value");
    textElement.textContent = variant[`option${button.dataset.optionPosition}`];
  });
}

class ParentFetch extends HTMLElement {
  constructor() {
    super();
  }

  get variantParents() {
    return JSON.parse(this.getAttribute("data-variant-parents"));
  }

  get productData() {
    return JSON.parse(document.querySelector(".product-json").innerHTML);
  }

  connectedCallback() {
    this._setupProducts();
  }

  _setupProducts() {
    if (!this.variantParents || this.variantParents.length === 0) {
      return;
    }
    window.productDataPromise.then((data) => {
      data.forEach((product) => {
        product.variants.forEach((variant) => {
          const skuFirstPart = variant.sku.split(".")[0];
          if (this.variantParents.includes(skuFirstPart)) {
            // Add the product handle to matchingProducts if not already present
            if (!this.matchingProducts) this.matchingProducts = [];
            if (
              !this.matchingProducts.some((p) => p.handle === product.handle)
            ) {
              this.matchingProducts.push(product);
            }

            // Check for custom form and add unique shapes
            const formValue = product.shape;
            if (formValue) {
              if (!this.shapes) this.shapes = [];
              if (!this.shapes.includes(formValue)) {
                this.shapes.push(formValue);
              }
            }

            // Break out of the inner loop (for variants)
            return;
          }
        });
      });

      if (this.matchingProducts) {
        this.innerHTML = `
          <div class="product-form__option-selector">
            <div class="variant-swatch-list">
              ${this.matchingProducts
                .map((product) => {
                  // Find the product object by handle
                  const currentProduct = window.productData.find(
                    (p) => p.handle === product.handle
                  );
                  if (
                    !currentProduct ||
                    !currentProduct.shape ||
                    currentProduct.shape !== this.productData.shape ||
                    !currentProduct.available ||
                    !currentProduct.featured_image
                  ) {
                    return "";
                  }

                  // Mark as selected if this is the current product
                  const isSelected =
                    this.productData.handle === currentProduct.handle;
                  return `
                      <option-rerender data-handle="${currentProduct.handle}" data-section-id="${this.getAttribute("data-section-id") || ""}">
                        <div class="variant-swatch${!currentProduct.available ? " is-disabled" : ""}">
                          <button class="variant-swatch__item${isSelected ? " is-selected" : ""}">
                            <span class="visually-hidden">${currentProduct.title || ""}</span>
                            <img
                              src="${currentProduct.featured_image}"
                              width="150"
                              loading="eager"
                              sizes="(max-width: 740px) 64px, 72px"
                              srcset="${currentProduct.featured_image} 64w, ${currentProduct.featured_image} 72w, ${currentProduct.featured_image} 128w, ${currentProduct.featured_image} 144w, ${currentProduct.featured_image} 192w, ${currentProduct.featured_image} 216w"
                              class="variant-swatch__image"
                              alt="${currentProduct.title || ""}"
                            >
                          </button>
                        </div>
                      </option-rerender>
                    `;
                })
                .join("")}
            </div>
          </div>
          ${
            this.shapes.length > 1
              ? `
            <button class="button button--text variant-picker-button" type="button" is="toggle-button" aria-controls="variant-picker-drawer" aria-expanded="false">
              ${a26Txt("Form wählen")} <span class="product-form__option-value">${a26Txt(this.productData.shape)}</span>
            </button>
          `
              : ""
          }
        `;
      }
    });
  }
}

customElements.define("parent-fetch", ParentFetch);

class ParentFetchDrawer extends HTMLElement {
  constructor() {
    super();
  }

  get variantParents() {
    return JSON.parse(this.getAttribute("data-variant-parents"));
  }

  get productData() {
    return JSON.parse(document.querySelector(".product-json").innerHTML);
  }

  get globalShapes() {
    return window.shopData.shapes;
  }

  connectedCallback() {
    this._setupProducts();
  }

  _setupProducts() {
    if (!this.variantParents || this.variantParents.length === 0) {
      return;
    }
    window.productDataPromise.then((data) => {
      data.forEach((product) => {
        product.variants.forEach((variant) => {
          const skuFirstPart = variant.sku.split(".")[0];
          if (this.variantParents.includes(skuFirstPart)) {
            // Add the product handle to matchingProducts if not already present
            if (!this.matchingProducts) this.matchingProducts = [];
            if (
              !this.matchingProducts.some((p) => p.handle === product.handle)
            ) {
              this.matchingProducts.push(product);
            }

            // Check for custom form and add unique shapes
            const formValue = product.shape;
            if (formValue) {
              if (!this.shapes) this.shapes = [];
              if (!this.shapes.includes(formValue)) {
                this.shapes.push(formValue);
              }
            }

            // Break out of the inner loop (for variants)
            return;
          }
        });
      });

      if (this.matchingProducts) {
        this.innerHTML = `
          <div class="product-form__option-selector">
          <h3 class="drawer__title heading h6">${a26Txt("Farbe wählen")}</h3>
            <div class="variant-swatch-list">
              ${this.matchingProducts
                .map((product) => {
                  // Find the product object by handle
                  const currentProduct = window.productData.find(
                    (p) => p.handle === product.handle
                  );
                  if (
                    !currentProduct ||
                    !currentProduct.shape ||
                    currentProduct.shape !== this.productData.shape ||
                    !currentProduct.available ||
                    !currentProduct.featured_image
                  ) {
                    return "";
                  }

                  // Mark as selected if this is the current product
                  const isSelected =
                    this.productData.handle === currentProduct.handle;
                  return `
                      <option-rerender data-handle="${currentProduct.handle}" data-section-id="${this.getAttribute("data-section-id") || ""}">
                        <div class="variant-swatch${!currentProduct.available ? " is-disabled" : ""}">
                          <button class="variant-swatch__item${isSelected ? " is-selected" : ""}">
                            <span class="visually-hidden">${currentProduct.title || ""}</span>
                            <img
                              src="${currentProduct.featured_image}"
                              width="150"
                              loading="eager"
                              sizes="(max-width: 740px) 64px, 72px"
                              srcset="${currentProduct.featured_image} 64w, ${currentProduct.featured_image} 72w, ${currentProduct.featured_image} 128w, ${currentProduct.featured_image} 144w, ${currentProduct.featured_image} 192w, ${currentProduct.featured_image} 216w"
                              class="variant-swatch__image"
                              alt="${currentProduct.title || ""}"
                            >
                          </button>
                        </div>
                      </option-rerender>
                    `;
                })
                .join("")}
            </div>
          </div>
          <div class="product-form__option-selector form-selector">
            <h3 class="drawer__title heading h6">${a26Txt("Form wählen")}</h3>
            <div class="variant-swatch-list">
              ${this.shapes
                .map((shape) => {
                  const currentShape = this.globalShapes.find(
                    (s) => s.label === shape
                  );
                  if (!currentShape) {
                    return "";
                  }
                  let targetProduct = null;

                  // Find matching product with same shape and color
                  this.matchingProducts.forEach((matchingProduct) => {
                    const productToCheck = data.find(
                      (p) => p.handle === matchingProduct.handle
                    );
                    if (productToCheck) {
                      const colorName = this.productData.color;
                      const colorToCheck = productToCheck.color;

                      if (
                        colorName === colorToCheck &&
                        productToCheck.shape === currentShape.label
                      ) {
                        targetProduct = productToCheck;
                      }
                    }
                  });

                  // Only render if product is available and has featured image
                  if (
                    targetProduct &&
                    targetProduct.available &&
                    targetProduct.featured_image
                  ) {
                    return `
                    <option-rerender data-handle="${targetProduct.handle}" data-section-id="${this.getAttribute("data-section-id") || ""}">
                      <div class="variant-swatch ${!targetProduct.available ? "is-disabled" : ""}">
                        <button class="variant-swatch__item ${this.productData.shape === currentShape.label ? "is-selected" : ""}">
                          <span class="visually-hidden">${targetProduct.title}</span>
                          
                          ${
                            currentShape.image
                              ? `<img src="${currentShape.image}" class="variant-swatch__image" loading="eager" sizes="(max-width: 740px) 64px, 72px" alt="${a26Txt(currentShape.label)}">`
                              : `<svg class="variant-swatch__image" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                              <rect width="100" height="100" fill="#f0f0f0"/>
                              <text x="50" y="50" text-anchor="middle" dy=".3em" fill="#999">?</text>
                            </svg>`
                          }
                        </button>
                        
                        <span class="variant-swatch__label">${a26Txt(currentShape.label)}</span>
                      </div>
                    </option-rerender>
                  `;
                  }
                  return ""; // Return empty string if no matching product
                })
                .join("")}
            </div>
          </div>
        `;
      }
    });
  }
}

customElements.define("parent-fetch-drawer", ParentFetchDrawer);

/* F245 (Fahim 29.10.2026): Bei Teppichen mit nur einer Farbe (bzw. nur einer Form) den Block „Farbe wählen“ / „Form wählen“
   oben auf der Produktseite und im Größen-Blatt ausblenden. Die grauen Lade-Platzhalter werden nicht mehr gezeigt (CSS in f245-stil). */
(function(){
  function pruefe(root){
    root.querySelectorAll('.product-form__option-selector').forEach(function(sel){
      var liste=sel.querySelector('.variant-swatch-list'); if(!liste || liste.classList.contains('variant-swatch-skeleton')) return;
      sel.hidden = sel.querySelectorAll('.variant-swatch').length <= 1;
    });
  }
  var beobachtet=new WeakSet();
  function an(el){ if(beobachtet.has(el)) return; beobachtet.add(el); pruefe(el); new MutationObserver(function(){ pruefe(el); }).observe(el,{childList:true,subtree:true}); }
  function suche(){ document.querySelectorAll('parent-fetch, parent-fetch-drawer').forEach(an); }
  function start(){ suche(); if(document.querySelector('parent-fetch, parent-fetch-drawer, variant-picker')){ new MutationObserver(suche).observe(document.body,{childList:true,subtree:true}); } }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',start); } else { start(); }
})();
